const NavbarSkeleton = () => (
  <div className="bg-bgClr-primary p-2 flex justify-end items-center animate-pulse">
    {/* Left side: Logo + Menu */}

    {/* Right side: Notification + Avatar */}
    <div className="flex justify-end space-x-4">
      <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
      <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
    </div>
  </div>
);

const SidebarSkeleton = () => (
  <div className="w-64 h-full bg-gray-100 p-4 animate-pulse space-y-4">
    {[...Array(6)].map((_, i) => (
      <div key={i} className="h-8 w-48 bg-gray-300 rounded"></div>
    ))}
  </div>
);
const ProjectsCardSkeleton = () => {
  return (
    <div className="py-3 px-2 animate-pulse">
      <div className="bg-white shadow-md rounded-md p-4">
        <div className="flex justify-between items-center">
          {/* Title */}
          <div className="h-6 w-24 bg-gray-300 rounded"></div>

          {/* Add Project Button */}
          <div className="hidden sm:flex items-center gap-x-2 bg-gray-200 px-3 py-1.5 rounded cursor-pointer">
            <div className="h-5 w-5 bg-gray-300 rounded-full"></div>
            <div className="h-4 w-20 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
const CandidateListSkeleton = () => {
  return (
    <div className="space-y-4 px-4 py-6 animate-pulse">
      {Array.from({ length: 6 }).map((_, idx) => (
        <div key={idx} className="flex items-center justify-between border-b pb-3 last:border-b-0">
          {/* Avatar + Name */}
          <div className="flex items-center gap-3 w-1/4">
            <div className="w-10 h-10 rounded-full bg-gray-300" />
            <div className="h-4 w-24 bg-gray-300 rounded" />
          </div>

          {/* Title */}
          <div className="h-4 w-20 bg-gray-300 rounded" />

          {/* Company */}
          <div className="h-4 w-24 bg-gray-300 rounded" />

          {/* LinkedIn */}
          <div className="h-4 w-28 bg-gray-300 rounded" />

          {/* Status */}
          <div className="h-6 w-20 bg-gray-300 rounded-full" />

          {/* Delete button (if visible) */}
          <div className="h-6 w-6 bg-gray-300 rounded-full" />
        </div>
      ))}
    </div>
  );
};

const ProjectOverviewSkeleton = () => (
  <div className="h-full min-h-0 overflow-y-auto animate-pulse">
    <div className="flex flex-col lg:flex-row gap-6 p-4">
      {/* Left side: Description */}
      <div className="flex-1 p-4 border border-gray-200 rounded-md bg-gray-50">
        <div className="h-6 w-48 bg-gray-300 rounded mb-4"></div>
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-4 bg-gray-300 rounded"></div>
          ))}
        </div>
      </div>

      {/* Right side: Details */}
      <div className="w-full lg:w-96 space-y-4">
        <div className="p-4 border rounded-md bg-gray-50">
          <div className="h-6 w-32 bg-gray-300 rounded mb-4"></div>
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="h-4 bg-gray-300 rounded"></div>
            ))}
          </div>
        </div>

        <div className="p-4 border rounded-md bg-gray-50">
          <div className="h-6 w-40 bg-gray-300 rounded mb-4"></div>
          <div className="h-10 w-full bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  </div>
);

const ProjectTitleSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-6 w-48 bg-gray-300 rounded"></div>
  </div>
);

const ProjectMenuItemsSkeleton = () => (
  <div className="overflow-x-auto scrollbar-hide mt-2 animate-pulse">
    <div className="flex items-center border-b-[1px] px-2 sm:px-4 min-w-max gap-2 sm:gap-4">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-center px-3 py-2 whitespace-nowrap text-sm sm:text-base flex-shrink-0">
          <div className="h-5 w-5 bg-gray-300 rounded mr-2"></div>
          <div className="h-4 w-16 bg-gray-300 rounded"></div>
        </div>
      ))}
    </div>
  </div>
);

export {
  NavbarSkeleton,
  SidebarSkeleton,
  ProjectsCardSkeleton,
  CandidateListSkeleton,
  ProjectOverviewSkeleton,
  ProjectMenuItemsSkeleton,
  ProjectTitleSkeleton,
};
